import type {
  Meta,
  PageableResponse,
  ScheduleEvent,
} from '~/types'

export const useScheduleEvents = (data: MaybeRef<Maybe<PageableResponse<ScheduleEvent.Model>>>) => {
  const items = computed<ScheduleEvent.Model[]>(() => unref(data)?.data ?? [])
  const meta = computed<Partial<Meta>>(() => unref(data)?.meta ?? {})
  const hasItems = computed<boolean>(() => items.value.length > 0)
  const hasMoreItems = computed<boolean>(() => {
    const { currentPage = 0, lastPage = 0 } = meta.value

    if (!hasItems.value || !currentPage || !lastPage) {
      return false
    }

    return currentPage < lastPage
  })

  return {
    hasItems,
    hasMoreItems,
    items,
    meta,
  }
}
